import { Controller } from "@hotwired/stimulus"

// Toggle the app shell sidebar between expanded (280px) and
// collapsed (72px, icons-only). Persists the choice in
// localStorage["sidebar-collapsed"] = "true" | "false".
//
// The first-paint guard in app/views/layouts/app.html.erb reads
// localStorage BEFORE this controller mounts and applies
// `<html data-sidebar-collapsed="true">` so the CSS picks up the
// collapsed width on first paint. Without that guard, returning
// collapsed-state users would see the sidebar flash from 280px to
// 72px as Stimulus boots.
export default class extends Controller {
  toggle() {
    const root = document.documentElement
    const next = root.dataset.sidebarCollapsed !== "true"
    root.dataset.sidebarCollapsed = next ? "true" : "false"
    this.element.setAttribute("aria-expanded", next ? "false" : "true")
    try {
      localStorage.setItem("sidebar-collapsed", next ? "true" : "false")
    } catch (e) {
      // localStorage blocked (private browsing on some browsers,
      // or user-disabled). Toggle still works for the session.
    }
  }

  connect() {
    // Sync aria-expanded with the current dataset state on mount,
    // so a screen-reader user landing on a page with the sidebar
    // already collapsed (via the first-paint guard) gets the
    // correct announcement.
    const isCollapsed = document.documentElement.dataset.sidebarCollapsed === "true"
    this.element.setAttribute("aria-expanded", isCollapsed ? "false" : "true")
  }
}
